<script setup lang="ts">
    import { VueFinalModal } from 'vue-final-modal';

    defineProps<{
        title?: string;
        bonus?: string;
        title_second?: string;
        button?: string;
        spins?: number;
        link?: string;
    }>();

    const emit = defineEmits<{
        (e: 'confirm'): void;
    }>();

    const spinClass = localStorage.getItem('currentSpin');
</script>

<template>
    <VueFinalModal
        :clickToClose="false"
        :escToClose="false"
    >
        <div class="vfm__content-wrap">
        <div class="counter-spin">
            {{ $t('modals.counter_spin') }} <span>{{ spins }}</span>
        </div>
        <h1 class="text-xl">
            {{ title }}{{ bonus }} <span class="text__second">{{ title_second }}</span>
        </h1>

        <a
            class="btn"
            :href="link"
            target="_blank"
            @click="emit('confirm')"
        >
            <div class="content">
                {{ button }}
            </div>
        </a>
        </div>
    </VueFinalModal>
</template>

<style lang="scss">
    @import '@/scss/variables.scss';
    @import '@/scss/mixins.scss';

    .vfm {
        &__overlay {
          background-color: rgba(0, 0, 0, .7);
        }

        &__content {
            padding-top: 20px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -58%);
            height: 535px;
            padding: 0;
            width: 546px;
            color: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            white-space: pre-line;
            text-align: center;
            font-style: normal;
            backdrop-filter: blur(2px);
            animation: backgroundChangeLarge 4s ease-in-out infinite;

            @include media-breakpoint('320') {
              width: calc(100% - 80px);
              min-width: 305px;
              background-size: contain !important;
              transform: translate(-50%, -50%);
            }

            @include media-breakpoint('540') {
              width: 546px;

            }

          @include media-breakpoint('1024') {
            height: 393px;
            padding: 0;
            width: 410px;
            transform: translate(-50%, -50%);
          }

          @include media-breakpoint('1366') {
            height: 535px;
            padding: 0;
            width: 546px;
            transform: translate(-50%, -55%);
          }

          @include media-breakpoint('1920') {
            transform: translate(-50%, -58%);
          }

            &::before {
              content: "";
              height: calc(100% - 96px);
              position: absolute;
              width: 100%;
              z-index: -1;
              bottom: 0;
              border-radius: 20px;
            }

            @include media-breakpoint('1024') {
              animation: backgroundChangeLarge 4s ease-in-out infinite;
            }

            @keyframes backgroundChange {
              0% {
                background: transparent url('@/img/modal/bg-lg.webp')
                no-repeat center;
              }
              50% {
                background: transparent url('@/img/modal/bg-lg.webp')
                no-repeat center;
              }
              100% {
                background: transparent url('@/img/modal/bg-lg.webp')
                no-repeat center;
              }
            }

            @keyframes backgroundChangeLarge {
              0% {
                background: transparent url('@/img/modal/bg-lg.webp')
                no-repeat center;
              }
              50% {
                background: transparent url('@/img/modal/bg-lg.webp')
                no-repeat center;
              }
              100% {
                background: transparent url('@/img/modal/bg-lg.webp')
                no-repeat center;
              }
            }

            &-wrap{
              display: flex;
              justify-content: center;
              flex-direction: column;
              align-items: center;
            }

            .counter-spin {
                position: absolute;
                top: 20px;
                text-align: center;
                text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.12);
                font-size: 13px;
                font-weight: 600;
                line-height: 130%;
                color: #20EAFF;
                right: calc(-50vw + 50% + 40px);

                @include media-breakpoint('320') {
                    font-size: 13px;
                }

                @include media-breakpoint('1024') {
                    top: calc(-50vh + 50% + 55px);
                    font-size: 13px;
                    span{
                      font-size: 18px;
                    }
                }

              @include media-breakpoint('1366') {
                top: calc(-50vh + 50% + 80px);
                font-size: 17px;
                span{
                  font-size: 24px;
                }
              }

              @include media-breakpoint('1920') {
                top: calc(-50vh + 50% + 110px);
                font-size: 24px;
                span{
                  font-size: 31px;
                }
              }

            }

            h1.text-xl {
              font-size: 42px;
              line-height: 130%;
              margin-bottom: 30px;
              font-family: "Gasoek One", sans-serif;
              font-weight: 400;
              font-style: normal;

              @include media-breakpoint('320') {
                font-size: 27px;
                line-height: 130%;
                margin-top: 70px;
                margin-bottom: 5px;
              }

              @include media-breakpoint('540') {
                font-size: 35px;
                line-height: 130%;
                margin-top: 80px;
                margin-bottom: 20px;
              }
              @include media-breakpoint('1024') {
                font-size: 35px;
              }

              @include media-breakpoint('1366') {
                font-size: 47px;
                margin-top: 100px;
                margin-bottom: 40px;
              }
              @include media-breakpoint('1920') {
                margin-bottom: 30px;
              }

            }

            .bonus {
                font-size: 28px;
                font-weight: 800;
                line-height: 130%;
                margin-bottom: 6px;

                @include media-breakpoint('1024') {
                    font-size: 60px;
                    line-height: 130%;
                }
            }

            .btn {
                width: 280px;
                height: 86px;
                background: url('@/img/modal/button-lg.png') no-repeat center;
                background-size: contain;
                display: flex;
                align-items: center;
                justify-content: center;
                column-gap: 8px;
                padding: 20px 30px;
                box-sizing: border-box;
                cursor: pointer;

              @include media-breakpoint('320') {
                height: 66px;
                padding: 0;
                width: 130px;
              }

              @include media-breakpoint('540') {
                background: url('@/img/modal/button-lg.png') no-repeat
                        center;
                background-size: contain;
                column-gap: 8px;
                width: 160px;
                font-size: 16px;
              }

              @include media-breakpoint('1366') {
                font-size: 21px;
                width: 210px;
              }

              .content {
                    font-size: 24px;
                    font-weight: 900;
                    line-height: 100%;
                    text-transform: uppercase;

                  @include media-breakpoint('320') {
                    font-size: 12px
                  }

                @include media-breakpoint('1024') {
                  font-size: 15px;
                }
                  @include media-breakpoint('1366') {
                    font-size: 21px;
                  }

                  @include media-breakpoint('1920') {
                    width: 280px;
                  }
              }
            }
        }
    }
</style>
